module.exports = __webpack_public_path__ + "img/Img2b_214867_BiEx-23-179.5c83eeb1.jpg";